import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';

export default class DailyAccountExpenseReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false
        };
        this.handleReportGeneration = this.handleReportGeneration.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
    }
    
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleReportGeneration(e){
        this.setState({isLoading: true});
        let url = "/api/v1/portal/finance/daily-account-expense-report/"+moment(this.state.startDate).format("YYYY-MM-DD")+"/"+moment(this.state.endDate).format("YYYY-MM-DD");
        return fetch(url,{
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              , "Accept": 'application/json',
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => response.blob())
        .then(blob => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = "Account Expense Report From "+moment(this.state.startDate).format("YYYY-MM-DD")+' To '+moment(this.state.endDate).format("YYYY-MM-DD")+".xlsx";
            document.body.appendChild(a); 
            a.click();    
            a.remove(); 
            this.setState({isLoading: false});
        }).catch(err=>{
           alert('sorry something went wrong.') ;
        });
    }
    
    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Daily Account Expense Report</h2>
                </div>
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={(e)=>this.handleStartDateChange(e)} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={(e)=>this.handleEndDateChange(e)} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button disabled={(this.state.isLoading) ? true : false} className="btn btn-primary btn-lg generate-daily-account-expense-report" onClick={(e)=>this.handleReportGeneration(e)}><b>Generate Report&nbsp;&nbsp;</b>
                            {this.state.isLoading ? (<span><i className="fa fa-spinner fa-pulse"></i></span>) : ""}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById(
    'react-component-g4-logistics-portal-daily-account-expense-report')) {
    ReactDOM.render(
    <DailyAccountExpenseReport
        message_if_none = 'Nothing to report on.'
        />,
    document.getElementById(
            'react-component-g4-logistics-portal-daily-account-expense-report'
            )
    );
}
